// extracted by mini-css-extract-plugin
export default {"link":"Link_link__6H6v1","active":"Link_active__da-Mg"};